import { render, staticRenderFns } from "./TopicPostComponent.vue?vue&type=template&id=6ce5e03c&"
import script from "./TopicPostComponent.vue?vue&type=script&lang=js&"
export * from "./TopicPostComponent.vue?vue&type=script&lang=js&"
import style0 from "./TopicPostComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports